<template>
    <div>

        <div
            id="payment-success"
            :class="hideRecu == true ? 'payment-success animated fadeIn text-center hidden' : 'payment-success animated fadeIn text-center'"
        >

            <img src="../assets/confirmico.gif" alt="Logo payment success" style="margin-top: -25px;" />

            <div>

                <strong v-if=" logoOfSelectedService != 'cash.png' ">
                    Paiement effectué avec succès ! <br><br>
                    <!-- Rechargement de <br> -->
                    <span style="font-weight: 900; font-size: 3rem;">
                        {{
                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant )
                        }} 
                    </span> 
                    <br>
                    <span class="display-for-large-only font-15" style=" align-items: center; justify-content: center;">
                        Par <img :src="require(`../assets/img/menu/${logoOfSelectedService}`)" width="53" alt="Logo" style="position: relative; left: 5px;" v-if="logoOfSelectedService"/>
                        <strong v-if="cinetPayService"> {{ cinetPayService }} </strong>
                    </span>

                    <span class="display-for-small-only font-15" style=" align-items: center; justify-content: center; ">
                        Par <img :src="require(`../assets/img/menu/${logoOfSelectedService}`)" width="53" alt="Logo" style="position: relative; left: 5px;" v-if="logoOfSelectedService"/>
                        <strong v-if="cinetPayService"> {{ cinetPayService }} </strong>
                    </span>
                    <br><br>
                
                    Pré-commande de {{ nombreCartes > 1 ? "cartes" : "carte" }} Visa.
                    <br><br>

                    <span v-if="choixLivraison == 'Agence'">
                        Veuillez vous rendre à notre agence
                        <strong v-if="lieuLivraison == '1'">
                            du Plateau pyramide, rue BCEAO, après le pullman hôtel. Résidence PELIEU 2e étage
                        </strong>
                        <strong v-if="lieuLivraison == '2'">
                            de Cocody Ambassade, Rue Booker Washington près du cabinet children of Africa
                        </strong>
                        <strong v-if="lieuLivraison == '4'">
                            de Marcory Zone 4 immeuble pistache et chocolat
                        </strong>
                        muni de votre pièce d'identité valide et votre reçu pour le retrait de {{ nombreCartes > 1 ? "vos cartes." : "votre carte." }}
                    </span>

                    <span v-if="choixLivraison == 'Domicile'">
                        Vous serez contacté pour la livraison de {{ nombreCartes > 1 ? "vos cartes." : "votre carte." }}
                    </span>


                </strong>

                <strong v-if=" logoOfSelectedService == 'cash.png' ">
                    Vous devrez payer le montant de <br><br>
                    <!-- Rechargement de <br> -->
                    <span style="font-weight: 900; font-size: 3rem;">
                        {{
                            new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( montant )
                        }} 
                    </span> 
                    <br><br>
                    <span class="display-for-large-only font-15" style=" align-items: center; justify-content: center; ">
                        À la récupération {{ nombreCartes > 1 ? 'de vos cartes' : 'de votre carte' }}.
                    </span>

                    <br><br>

                    <span v-if="choixLivraison == 'Agence'">
                        Veuillez vous rendre à notre agence
                        <strong v-if="lieuLivraison == '1'">
                            du Plateau pyramide, rue BCEAO, après le pullman hôtel. Résidence PELIEU 2e étage
                        </strong>
                        <strong v-if="lieuLivraison == '2'">
                            de Cocody Ambassade, Rue Booker Washington près du cabinet children of Africa
                        </strong>
                        <strong v-if="lieuLivraison == '4'">
                            de Marcory Zone 4 immeuble pistache et chocolat
                        </strong>
                        muni de votre pièce d'identité valide et votre reçu pour le retrait de votre (vos) carte(s).
                    </span>

                    <span v-if="choixLivraison == 'Domicile'">
                        Vous serez contacté pour la livraison de votre (vos) carte(s).
                    </span>

                </strong>

            </div>

        </div>

        <div class="element-wrap element-wrap-for-submit mt-5 mb-5"> 
            <a :href="'javascript:;'" class="btn btn-dark btn-block font-15"
                v-if="!hideRecu" @click="printPdf"
            >
                Votre reçu
            </a>
            
            <a href="https://apaym.com/app" target="_blank" 
                :class="hideRecu == true ? 'btn btn-dark hidden btn-block' : 'btn btn-outline-dark btn-block font-15'"
            >
                Facilite tes paiements, télécharge APAYM
            </a>

            <button @click="reload" style="font-weight: 800; color: #0e2abd;"
                :class="hideRecu == true ? 'btn btn-link hidden btn-block' : 'btn btn-link btn-block'" 
            >
                Commander {{ nombreCartes > 1 ? "d'autres cartes" : "une autre carte" }}
            </button>

        </div>


    </div>
</template>

<script>

    export default {
        components:{
        },
        data() {
            return {
            }
        },
        props: [ 
            'hideRecu', 'logoOfSelectedService', 'montant',
            'cinetPayService', 'nombreCartes', 'printPdfRecu',
            'lieuLivraison', 'choixLivraison'
        ],
        mounted(){
        },
        methods: {
            // Reload la page
            reload(){
                window.location.reload();
            },

            printPdf()
            {
                this.printPdfRecu();
            },
        },
    }
</script>

<style scoped>

    

</style>